
/**
 * 描述：新华社稿
 * 日期：2017-8-22
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('resourceCenterXinhuaModule').directive('xinhuaLeft', [
    'resourceCenterService',
    '$state',
    'messagePublishService',
    'xinhuaApiService',
    function(resourceCenterService, $state, messagePublishService, xinhuaApiService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: './resourceCenter/XinhuaNews/left/left_tpl.html',
            scope: {
                selectedParent: '=',
            },
            link: function($scope, $elem, $attr) {
                initStatus();
                initData({
                    LINECLASSIFYID: $state.params.fcode,
                    XHSTYPENAME: $state.params.nodename
                });

                /**
                 * [selectLeve3 description] 选中新华社稿三级菜单
                 * @param  {[type]} item [description] 三级菜单信息
                 * @return {[type]}      [description]
                 */
                $scope.selectLeve3 = function(item) {
                    $scope.status.selected = item ? item.LINECLASSIFYID : '';
                    let params = {
                        parentfcode: $scope.selectedParent.value.TENANTXHSTYPEID,
                        nodename: item ? item.XHSTYPENAME : undefined,
                        fcode: item ? item.LINECLASSIFYID : undefined,
                        doctype: $scope.selectedParent.value.DOCTYPE
                    };
                    resourceCenterService.go('front.resourcectrl.xinhua.resource', params);
                };

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                    $scope.status.selected = getInitSelected();
                    // watchParent();
                    messagePublishService.subscribe(
                        'xinhuaThridNavChange',
                        function (event, data) {
                            initData();
                        },
                        $scope
                    );
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    xinhuaApiService.getXinhuaClassfiy($scope.selectedParent.value.TENANTXHSTYPEID).then(function(data) {
                        $scope.data.navList = data;
                        $scope.selectLeve3(data[0]);
                    });
                }

                /**
                 * [watchParent description] 监控父节点变化
                 * @return {[type]} [description]
                 */
                function watchParent() {
                    $scope.$watch('selectLeve3', (newV, oldV) => {
                        if (newV.fcode === oldV.fcode) {
                            return;
                        }
                        $scope.status.selected = '';
                    });
                }

                /**
                 * [getInitSelected 初始化选中的菜单项]
                 *
                 * @return  {[type]}  [return description]
                 */
                function getInitSelected(){
                    let nodename = $state.params.nodename;
                    return nodename;
                }
            },
        };
    },
]);
